import { useMemo } from "external/react"

export default function useTextMeasurer (props) {
    const {fontSize, fontFamily = 'sans-serif'} = props
    const measureText = useMemo(() => {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        context.font = `${fontSize} ${fontFamily}`
        return text => context.measureText(text).width
    }, [fontSize, fontFamily])
    return measureText
}